/**
 * AX-IOM — Premium Investment Intelligence Platform
 * © 2025 AX-IOM. Licensed to 2bintec - 78, avenue des Champs Elysées, 75008 Paris
 * 
 * Refactored modular architecture
 */

import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import LandingPage from './pages/LandingPage';
import MainApp from './pages/MainApp';

const App = () => {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<MainApp />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
};

export default App;
